export default "__VITE_ASSET__CjHiCEIV__"